import {
  GET_FAMILY_CLAN_LEVEL,
  CREATE_NEW_FAMILY_CLAN_LEVEL,
  OPEN_FAMILY_CLAN_LEVEL_DIALOG,
  CLOSE_FAMILY_CLAN_LEVEL_DIALOG,
  EDIT_FAMILY_CLAN_LEVEL,
  DELETE_FAMILY_CLAN_LEVEL,
} from "./types";

const initialState = {
  familyClanLevel: [],
  dialog: false,
  dialogData: null,
};

const familyClanLevelReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FAMILY_CLAN_LEVEL:
      return {
        ...state,
        familyClanLevel: action.payload,
      };
    case CREATE_NEW_FAMILY_CLAN_LEVEL:
      const data = [...state.familyClanLevel];
      data.unshift(action.payload);
      return {
        ...state,
        familyClanLevel: data,
      };
    case EDIT_FAMILY_CLAN_LEVEL:
      return {
        ...state,
        familyClanLevel: state.familyClanLevel.map((level) => {
          if (level._id === action.payload.id) return action.payload.data;
          else return level;
        }),
      };
    case DELETE_FAMILY_CLAN_LEVEL:
      return {
        ...state,
        familyClanLevel: state.familyClanLevel.filter(
          (level) => level._id !== action.payload,
        ),
      };
    case OPEN_FAMILY_CLAN_LEVEL_DIALOG:
      return {
        ...state,
        dialog: true,
        dialogData: action.payload || null,
      };
    case CLOSE_FAMILY_CLAN_LEVEL_DIALOG:
      return {
        ...state,
        dialog: false,
        dialogData: null,
      };

    default:
      return state;
  }
};

export default familyClanLevelReducer;
